import React, { createContext, useContext, useState, useEffect } from 'react';
import { EndPointGetDepartments, EndPointDeleteDepartment, EndPointCreateUpdateDepartment } from '../Services/EndPointDepartment';
export const GerenciaContext = createContext();

// Custom hook to use the Operation context
export const useGerencia = () => {
  const context = useContext(GerenciaContext);
  if (!context) {
    throw new Error('useGerencia must be used within an GerenciaProvider');
  }
  return context;
};

// Provider component
export const GerenciaProvider = ({ children }) => {
  const [miningSite, setMiningSite] = useState(0);
  const [nameFilter, setNameFilter] = useState('');
  const [idFilter, setIdFilter] = useState('');
  const [openSave, setOpenSave] = useState(false);
  const [selected, setSelected] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [deleteItem, setDeleteItem] = useState(null);

  const fetchDepartments = async () => {
    try {
      const response = await EndPointGetDepartments(miningSite, nameFilter, idFilter);
      const ingresosData = response.data.data || [];
      setDepartments(ingresosData);
      setSelected(null);
    } catch (error) {
      console.error('Error fetching departments:', error);
    }
  };

  const doDelete = async () => {
    try {
      await EndPointDeleteDepartment(deleteItem.departmentId, miningSite);
      setSelected(null);
      setDepartments(departments.filter((item) => item.departmentId !== deleteItem.departmentId));
      setDeleteItem(null);
    } catch (error) {
      console.error('Error deleting departments:', error);
    }
  };

  useEffect(() => {

    if (miningSite === 0) {
      setDepartments([]);
      return;
    }

    fetchDepartments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [miningSite, nameFilter, idFilter]);


  const doSave = async (form) => {
    try {
      console.log({ form });
      const response = await EndPointCreateUpdateDepartment({...form, miningSiteId: miningSite, id: form.id || null });

      if (!response.data.success){
        return;
      }
      fetchDepartments();
      setOpenSave(true); 
    } catch (error) {
      console.error('Error saving department:', error);
    }
  }


  const contextValue = {
    miningSite,
    nameFilter,
    idFilter,
    selected,
    departments,
    deleteItem,
    openSave,
    setOpenSave,
    setMiningSite,
    setNameFilter,
    setIdFilter,
    setSelected,
    setDeleteItem,

    doSave,
    doDelete,
  };

  return (
    <GerenciaContext.Provider value={contextValue}>
      {children}
    </GerenciaContext.Provider>
  );
}